/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycFormSnapshotSummaryDto } from '../../models/kyc-form-snapshot-summary-dto';

export interface ListFormVersions$Params {
  id: string;
}

export function listFormVersions(http: HttpClient, rootUrl: string, params: ListFormVersions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KycFormSnapshotSummaryDto>>> {
  const rb = new RequestBuilder(rootUrl, listFormVersions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KycFormSnapshotSummaryDto>>;
    })
  );
}

listFormVersions.PATH = '/kyc/processes/{id}/form-versions';
